export const truncate = (word: string, maxSize: number): string => {
    if (word === undefined || word === null) {
        return
    }
    if (word.length > maxSize) {
        return word.substring(0, maxSize - 3) + '...'
    } else {
        return word
    }
}
